import { render, staticRenderFns } from "./Yasu3.vue?vue&type=template&id=354262e8&scoped=true"
import script from "./Yasu3.vue?vue&type=script&lang=js"
export * from "./Yasu3.vue?vue&type=script&lang=js"
import style0 from "./Yasu3.vue?vue&type=style&index=0&id=354262e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354262e8",
  null
  
)

export default component.exports